"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpiryObjectStorage = void 0;
var Json_1 = require("../../Json");
var useExpiryTypedStorage_1 = require("../useExpiryTypedStorage");
function useExpiryObjectStorage(stroage, key, options) {
    var _a = options || {}, _b = _a.encoder, encoder = _b === void 0 ? function (v) { return v === null ? 'null' : Json_1.Json.stringify(v); } : _b, _c = _a.decoder, decoder = _c === void 0 ? function (v) { return v === null ? null : Json_1.Json.safeParse(v, null); } : _c, _d = _a.defaultValue, defaultValue = _d === void 0 ? null : _d;
    return (0, useExpiryTypedStorage_1.useExpiryTypedStorage)(stroage, key, { encoder: encoder, decoder: decoder, defaultValue: defaultValue });
}
exports.useExpiryObjectStorage = useExpiryObjectStorage;
//# sourceMappingURL=index.js.map